import { NoticeFilled, RemindCircle, RemindMinusFilled } from '@pets-ui/icons'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type CouponConditionProps } from './CouponCondition'

export interface CouponConditionPrefixIconProps {
  isApplied?: CouponConditionProps['isApplied']
  moreAmount?: CouponConditionProps['moreAmount']
  moreQuantity?: CouponConditionProps['moreQuantity']
}

export const CouponConditionPrefixIcon = (props: CouponConditionPrefixIconProps) => {
  const { isApplied, moreAmount, moreQuantity } = props
  if (isApplied) return <RemindCircle color={colors.green600} fontSize={16} />
  if (moreAmount || moreQuantity) return <NoticeFilled color={colors.yellow600} fontSize={16} />
  return <RemindMinusFilled color={colors.grey500} fontSize={16} />
}
